// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as ReactDOMStyle from "@rescript/react/lib/es6/src/ReactDOMStyle.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as JsxRuntime from "react/jsx-runtime";

import '@fortawesome/fontawesome-free/css/all.css'
;

function toClass(s) {
  let tmp;
  switch (s) {
    case "Xxs" :
      tmp = "2xs";
      break;
    case "Xs" :
      tmp = "xs";
      break;
    case "Sm" :
      tmp = "sm";
      break;
    case "Lg" :
      tmp = "lg";
      break;
    case "Xl" :
      tmp = "xl";
      break;
    case "Xxl" :
      tmp = "2xl";
      break;
  }
  return "fa-" + tmp;
}

let RelativeSize = {
  toClass: toClass
};

function toClass$1(s) {
  if (s.TAG === "Relative") {
    return toClass(s._0);
  } else {
    return `fa-` + s._0.toString() + `x`;
  }
}

let Size = {
  toClass: toClass$1
};

function FontAwesome$Icon(props) {
  let __inverse = props.inverse;
  let stack = props.stack;
  let __rotate = props.rotate;
  let __pulse = props.pulse;
  let __spin = props.spin;
  let spin = __spin !== undefined ? __spin : false;
  let pulse = __pulse !== undefined ? __pulse : false;
  let rotate = __rotate !== undefined ? __rotate : 0;
  let inverse = __inverse !== undefined ? __inverse : false;
  let match;
  let exit = 0;
  if (rotate < 180) {
    if (rotate !== 0) {
      if (rotate !== 90) {
        exit = 1;
      } else {
        match = [
          ["fa-rotate-90"],
          undefined
        ];
      }
    } else {
      match = [
        [],
        undefined
      ];
    }
  } else if (rotate !== 180) {
    if (rotate !== 270) {
      exit = 1;
    } else {
      match = [
        ["fa-rotate-270"],
        undefined
      ];
    }
  } else {
    match = [
      ["fa-rotate-180"],
      undefined
    ];
  }
  if (exit === 1) {
    match = [
      ["fa-rotate-by"],
      [
        "--fa-rotate-angle",
        rotate.toString() + `deg`
      ]
    ];
  }
  let style = Stdlib_Option.map(match[1], param => ReactDOMStyle.unsafeAddProp({}, param[0], param[1]));
  return JsxRuntime.jsx("i", {
    className: LumiReact.classList([
      [
        props.variant,
        true
      ],
      [
        "fa-" + props.name,
        true
      ],
      [
        "fa-spin",
        spin
      ],
      [
        "fa-pulse",
        pulse
      ],
      [
        "fa-stack-1x",
        Primitive_object.equal(stack, "Small")
      ],
      [
        "fa-stack-2x",
        Primitive_object.equal(stack, "Large")
      ],
      [
        "fa-inverse",
        inverse
      ],
      Stdlib_Option.mapOr(props.className, [
        "",
        false
      ], n => [
        n,
        true
      ]),
      Stdlib_Option.mapOr(props.size, [
        "",
        false
      ], s => [
        toClass$1(s),
        true
      ])
    ].concat(match[0].map(x => [
      x,
      true
    ]))),
    style: style
  });
}

let Icon = {
  RelativeSize: RelativeSize,
  Size: Size,
  make: FontAwesome$Icon
};

function FontAwesome$Solid(props) {
  let __inverse = props.inverse;
  let __rotate = props.rotate;
  let __pulse = props.pulse;
  let __spin = props.spin;
  let spin = __spin !== undefined ? __spin : false;
  let pulse = __pulse !== undefined ? __pulse : false;
  let rotate = __rotate !== undefined ? __rotate : 0;
  let inverse = __inverse !== undefined ? __inverse : false;
  return JsxRuntime.jsx(FontAwesome$Icon, {
    variant: "fas",
    name: props.name,
    spin: spin,
    pulse: pulse,
    rotate: rotate,
    stack: props.stack,
    inverse: inverse,
    size: props.size,
    className: props.className
  });
}

let Solid = {
  make: FontAwesome$Solid
};

function FontAwesome$Regular(props) {
  let __inverse = props.inverse;
  let __rotate = props.rotate;
  let __pulse = props.pulse;
  let __spin = props.spin;
  let spin = __spin !== undefined ? __spin : false;
  let pulse = __pulse !== undefined ? __pulse : false;
  let rotate = __rotate !== undefined ? __rotate : 0;
  let inverse = __inverse !== undefined ? __inverse : false;
  return JsxRuntime.jsx(FontAwesome$Icon, {
    variant: "far",
    name: props.name,
    spin: spin,
    pulse: pulse,
    rotate: rotate,
    stack: props.stack,
    inverse: inverse,
    size: props.size,
    className: props.className
  });
}

let Regular = {
  make: FontAwesome$Regular
};

function FontAwesome$Brand(props) {
  let __inverse = props.inverse;
  let __rotate = props.rotate;
  let __pulse = props.pulse;
  let __spin = props.spin;
  let spin = __spin !== undefined ? __spin : false;
  let pulse = __pulse !== undefined ? __pulse : false;
  let rotate = __rotate !== undefined ? __rotate : 0;
  let inverse = __inverse !== undefined ? __inverse : false;
  return JsxRuntime.jsx(FontAwesome$Icon, {
    variant: "fab",
    name: props.name,
    spin: spin,
    pulse: pulse,
    rotate: rotate,
    stack: props.stack,
    inverse: inverse,
    size: props.size,
    className: props.className
  });
}

let Brand = {
  make: FontAwesome$Brand
};

function FontAwesome$Stack(props) {
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: "fa-stack"
  });
}

let Stack = {
  make: FontAwesome$Stack
};

export {
  Icon,
  Solid,
  Regular,
  Brand,
  Stack,
}
/*  Not a pure module */
